import { Link } from 'react-router-dom';

const Footer = () => {
  const mainPages = [
    { name: 'Services', path: '/services' },
    { name: 'Recent Projects', path: '/projects' },
    { name: 'Prices', path: '/prices' },
    { name: 'FAQ\'s', path: '/faqs' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact Us', path: '/contact' },
  ];

  const servicePages = [
    { name: 'Web Design', path: '/services/web-design' },
    { name: 'Business Listings', path: '/services/business-listings' },
    { name: 'Local SEO', path: '/services/local-seo' },
    { name: 'PPC Ad Management', path: '/services/ppc-ad-campaign-management' },
    { name: 'Google My Business', path: '/services/google-my-business-management' },
    { name: 'Digital Marketing', path: '/services/digital-marketing' },
    { name: 'SEO Services', path: '/services/seo' },
    { name: 'Social Media', path: '/services/social-media' },
    { name: 'Content Marketing', path: '/services/content' },
    { name: 'Virtual Tours', path: '/services/virtual-tours' },
    { name: 'Reputation Management', path: '/services/reputation' },
    { name: 'Analytics & Reporting', path: '/services/reporting-analytics' },
  ];

  const blogCategories = [
    { name: 'Digital Marketing Tips', path: '/blog' },
    { name: 'Local SEO', path: '/blog' },
    { name: 'Free Marketing Tools', path: '/blog' },
    { name: 'Social Media Tips', path: '/blog' },
    { name: 'Startup Budgets', path: '/blog' },
  ];

  const legalPages = [
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Cookie Use Policy', path: '/cookies' },
  ];

  // Validate page data to prevent runtime errors
  const validatePageLink = (page) => {
    if (!page || typeof page !== 'object' || !page.name || !page.path) {
      console.warn('Invalid page data:', page);
      return false;
    }
    return true;
  };

  try {
    return (
      <footer className="bg-gradient-to-r from-teal-700 via-emerald-600 to-green-600 text-white relative z-40">
        <div className="px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            <div className="col-span-1 md:col-span-1">
              <Link to="/" className="flex items-center space-x-2 mb-4 cursor-pointer">
                <div className="text-white font-bold text-2xl" style={{ fontFamily: '"Pacifico", serif' }}>
                  Digital Experience Studio
                </div>
              </Link>
              <p className="text-gray-200 mb-4">
                Premium digital marketing solutions for small businesses. We help you grow through professional website design and strategic marketing.
              </p>
              <div className="flex space-x-4">
                <a 
                  href="https://www.facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-colors cursor-pointer"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a 
                  href="https://www.instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-colors cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
                <a 
                  href="https://www.twitter.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-colors cursor-pointer"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-x-fill text-xl"></i>
                </a>
                <a 
                  href="https://www.linkedin.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-colors cursor-pointer"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                {mainPages.filter(validatePageLink).map((page) => (
                  <li key={page.path}>
                    <Link
                      to={page.path}
                      className="text-gray-200 hover:text-yellow-300 transition-colors cursor-pointer"
                    >
                      {page.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold mb-4">Our Services</h3>
              <ul className="space-y-2">
                {servicePages.filter(validatePageLink).slice(0, 8).map((page) => (
                  <li key={page.path}>
                    <Link
                      to={page.path}
                      className="text-gray-200 hover:text-yellow-300 transition-colors cursor-pointer"
                    >
                      {page.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold mb-4">Blog & Resources</h3>
              <ul className="space-y-2 mb-4">
                {blogCategories.filter(validatePageLink).map((category) => (
                  <li key={category.name}>
                    <Link
                      to={category.path}
                      className="text-gray-200 hover:text-yellow-300 transition-colors cursor-pointer"
                    >
                      {category.name}
                    </Link>
                  </li>
                ))}
              </ul>
              <Link
                to="/blog"
                className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full font-semibold hover:bg-white/30 transition-colors cursor-pointer border border-white/30"
              >
                View All Posts
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div>
              <h3 className="text-xl font-bold mb-4">Get Started</h3>
              <div className="space-y-3 mb-6">
                <Link
                  to="/consultation"
                  className="block bg-yellow-400 text-teal-900 px-4 py-2 rounded-full font-bold hover:bg-yellow-300 transition-colors duration-300 whitespace-nowrap cursor-pointer text-center"
                >
                  Book Free Consultation
                </Link>
                <Link
                  to="/quote"
                  className="block bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full font-bold hover:bg-white/30 transition-colors duration-300 whitespace-nowrap cursor-pointer text-center border border-white/30"
                >
                  Request Free Quote
                </Link>
              </div>
              
              <h4 className="text-lg font-bold mb-3">Legal</h4>
              <ul className="space-y-2">
                {legalPages.filter(validatePageLink).map((page) => (
                  <li key={page.path}>
                    <Link
                      to={page.path}
                      className="text-gray-200 hover:text-yellow-300 transition-colors cursor-pointer"
                    >
                      {page.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="border-t border-white/20 mt-8 pt-8 text-center">
            <p className="text-gray-200">
              © 2024 Digital Experience Studio. All rights reserved. | 
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-yellow-300 hover:text-yellow-200 ml-1 cursor-pointer"
              >
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    );
  } catch (error) {
    console.error('Error rendering Footer component:', error);
    return (
      <footer className="bg-teal-700 text-white p-6 text-center">
        <p>© 2024 Digital Experience Studio. All rights reserved.</p>
      </footer>
    );
  }
};

export default Footer;
